export const triton_connect = [
  {
    number: 'TC100',
    hasModel: false,
  },
  {
    number: 'TC101',
    hasModel: true,
  },
  {
    number: 'TC102',
    hasModel: true,
  },
  {
    number: 'TC103',
    hasModel: true,
  },
  {
    number: 'TC104',
    hasModel: true,
  },
  {
    number: 'TC105',
    hasModel: false,
  },
  {
    number: 'TC106',
    hasModel: true,
  },
  {
    number: 'TC107',
    hasModel: true,
  },
  {
    number: 'TC108',
    hasModel: false,
  },
  {
    number: 'TC109',
    hasModel: false,
  },
  {
    number: 'TC110',
    hasModel: false,
  },
  {
    number: 'TC111',
    hasModel: true,
  },
  {
    number: 'TC112',
    hasModel: true,
  },
  {
    number: 'TC113',
    hasModel: false,
  },
  {
    number: 'TC114',
    hasModel: false,
  },
  {
    number: 'TC115',
    hasModel: false,
  },
  {
    number: 'TC116',
    hasModel: false,
  },
  {
    number: 'TC117',
    hasModel: false,
  },
  {
    number: 'TC118',
    hasModel: false,
  },
  {
    number: 'TC119',
    hasModel: false,
  },
  {
    number: 'TC120',
    hasModel: true,
  },
  {
    number: 'TC121',
    hasModel: false,
  },
  {
    number: 'TC122',
    hasModel: false,
  },
  {
    number: 'TC123',
    hasModel: false,
  },
  {
    number: 'TC124',
    hasModel: true,
  },
  {
    number: 'TC125',
    hasModel: true,
  },
  {
    number: 'TC126',
    hasModel: false,
  },
  {
    number: 'TC127',
    hasModel: true,
  },
  {
    number: 'TC128',
    hasModel: false,
  },
  {
    number: 'TC129',
    hasModel: false,
  },
  {
    number: 'TC130',
    hasModel: false,
  },
  {
    number: 'TC131',
    hasModel: false,
  },
  {
    number: 'TC132',
    hasModel: false,
  },
  {
    number: 'TC133',
    hasModel: false,
  },
  {
    number: 'TC134',
    hasModel: false,
  },
  {
    number: 'TC135',
    hasModel: true,
  },
  {
    number: 'TC136',
    hasModel: false,
  },
  {
    number: 'TC137',
    hasModel: false,
  },
  {
    number: 'TC138',
    hasModel: false,
  },
  {
    number: 'TC139',
    hasModel: false,
  },
  {
    number: 'TC140',
    hasModel: false,
  },
  {
    number: 'TC141',
    hasModel: false,
  },
  {
    number: 'TCX',
    hasModel: false,
  },
];
